import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Redux } from 'src/store'
import { Loyalty, UpdateLoyalty, GygLoyaltyStateType } from 'src/types/apps/gygLoyaltyTypes'
import { LOYALTY_SLICE_NAME, GET_LOYALTY_BY_USER_ID_ACTION, UPDATE_GYG_POINTS_DOLLAR } from 'src/store/action'

interface LoyaltyResponse {
  data: Loyalty
}

interface updateGYGPointDollarPayload {
  userId: string
  data: UpdateLoyalty
}

interface UserErrorReponse {
  title: string
  message: any[] | string
  statusCode: number
}

export const getLoyaltyByUserId = createAsyncThunk<LoyaltyResponse, string, Redux>(
  GET_LOYALTY_BY_USER_ID_ACTION,
  async (userId: string, { extra }) => {
    const response = await extra.httpClient(`loyalty/stats?userId=${userId}`)

    return response.data
  }
)

export const updateGYGPointDollar = createAsyncThunk<LoyaltyResponse, updateGYGPointDollarPayload, Redux>(
  UPDATE_GYG_POINTS_DOLLAR,
  async ({ userId, data }, { extra, rejectWithValue }) => {
    try {
      const response = await extra.httpClient(`/loyalty/user/${userId}`, { method: 'PATCH', data })

      return response.data
    } catch (error: any) {
      if (error.response) {
        return rejectWithValue(error.response.data)
      }

      return rejectWithValue(error.message)
    }
  }
)

const initialState: GygLoyaltyStateType = {
  gygLoyalty: null,
  getLoyaltyPending: false,
  resyncTaskPending: false,
  updateGYGPointDollarPending: false,
  error: null,
  success: undefined
}

export const gygLoyaltySlice = createSlice({
  name: LOYALTY_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getLoyaltyByUserId.fulfilled, (state, action) => {
        state.getLoyaltyPending = false
        state.success = undefined
        state.error = null
        state.gygLoyalty = action.payload.data
      })
      .addCase(getLoyaltyByUserId.pending, state => {
        state.getLoyaltyPending = true
      })
      .addCase(getLoyaltyByUserId.rejected, state => {
        state.getLoyaltyPending = false
        state.success = undefined
        state.error = null
      })

      .addCase(updateGYGPointDollar.fulfilled, (state, action) => {
        state.updateGYGPointDollarPending = false
        state.success = 'Gomex Rewards Updated'
        state.error = null
        state.gygLoyalty = action.payload.data
      })
      .addCase(updateGYGPointDollar.pending, state => {
        state.updateGYGPointDollarPending = true
        state.error = null
        state.success = undefined
      })
      .addCase(updateGYGPointDollar.rejected, (state, action) => {
        let errors: any
        if (action.payload !== undefined && (action.payload as UserErrorReponse)) {
          errors = action.payload as UserErrorReponse
        } else {
          errors = action.payload
        }
        state.error = errors
        state.success = undefined
        state.updateGYGPointDollarPending = false
      })
  }
})

export default gygLoyaltySlice.reducer
